<template>
  <a-config-provider :locale="locale">
    <div class="app-shell">
      <nav-bar />
      <div class="app-content">
        <router-view />
      </div>
      <zui-footer />
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import NavBar from './NavBar'
  import ZuiFooter from './Footer'
  export default {
    name: 'app',
    components: { NavBar, ZuiFooter },
    data() {
      return {
        locale: zhCN
      }
    }
  }
</script>
<style lang="less">
.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.app-content {
  flex: 1;
  padding-top: 64px;
}
@media (max-width: 768px) {
  .app-content {
    padding-top: 56px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue